const ACCOUNT_SETTINGS_SCREENS = {
  PERSONAL_INFO: "PERSONAL_INFO",
  PASSWORD: "PASSWORD",
};

export default ACCOUNT_SETTINGS_SCREENS;
